import { APICore } from '../../helpers/api/apiCore';
import * as URL from '../../helpers/api/apiEndPoint';

const api = new APICore();

function createSupport(params: any): any {
    const { data } = params;
    return api.create(URL.POST_SUPPORT, data);
}

function support(data: any): any {
    let { status, userId, limit, pages } = data?.data;
    // search, limit, pages,
    return api.get(
        `${URL.GET_SUPPORT}?userId=${userId}&status=${status}&limit=${limit}&page=${pages}`
        // &search=${search}&limit=${limit}&page=${pages}
    );
}
function updateSupport(params: any): any {
    const { data } = params;
    return api.update(URL.UPDATE_SUPPORT_ADMIN, data);
}

function supportAdmin(data: any): any {
    let { status, limit, pages } = data?.data;
    return api.get(
        `${URL.GET_SUPPORT_ADMIN}?status=${status}&limit=${limit}&page=${pages}`
        // ?userId=${userId}&status=${status}&search=${search}&limit=${limit}&page=${pages}
    );
}

function createChat(params: any): any {
    const { data } = params;
    return api.create(URL.POST_CHAT, data);
}

function getChat(params: any): any {
    const { data } = params;
    return api.get(`${URL.GET_CHAT}?filter=${JSON.stringify(data)}`);
}

function getTicketById(data: any): any {
    const { id } = data?.data
    return api.get(`${URL.GET_TICKET_BY_ID}/${id}`)
}

export { createSupport, support, supportAdmin, updateSupport, createChat, getChat, getTicketById };
